module.exports = __webpack_public_path__ + "static/img/ECOP_2@2x.9be97919.png";